import React from 'react';
import Link from 'next/link';
import { sitePath } from '@/utils/links/safeHref';

export interface SymbolLinkGroup {
    title: string;
    links: { symbol: string; label: string }[];
}

interface SymbolLinksProps {
    groups: SymbolLinkGroup[];
    currentSymbol?: string;
}

/**
 * Plain links to every gold & fiat symbol page (no prices, no sockets), so each price page is one
 * click from every other one. The live widget only covers the key symbols; this reaches the rest.
 */
const SymbolLinks: React.FC<SymbolLinksProps> = ({ groups, currentSymbol }) => {
    const current = currentSymbol?.toLowerCase();
    const visible = groups
        .map((group) => ({ ...group, links: group.links.filter((l) => l.symbol !== current) }))
        .filter((group) => group.links.length > 0);
    if (visible.length === 0) return null;

    return (
        <div className='flex w-full flex-col gap-4'>
            {visible.map((group) => (
                <nav key={group.title} aria-label={group.title} className='w-full'>
                    <h3 className='mb-2 text-xs font-bold text-zinc-500 dark:text-gray-400'>
                        {group.title}
                    </h3>
                    <ul className='flex flex-wrap gap-2'>
                        {group.links.map((link) => (
                            <li key={link.symbol}>
                                <Link
                                    href={sitePath('symbol', link.symbol) ?? '#'}
                                    prefetch={false}
                                    className='inline-block rounded-lg border border-gray-200 bg-white px-2.5 py-1 text-xs text-zinc-700 transition-colors hover:border-blue-300 hover:text-blue-600 dark:border-white/10 dark:bg-white/5 dark:text-gray-200 dark:hover:border-blue-400/50 dark:hover:text-white'
                                >
                                    قیمت {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            ))}
        </div>
    );
};

export default SymbolLinks;
